"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryTags = exports.DictionaryTagsSerializer = void 0;
// MIT © 2017 azu
var DictionaryTag_1 = require("./DictionaryTag");
exports.DictionaryTagsSerializer = {
    fromJSON: function (json) {
        if (json === void 0) { json = []; }
        return new DictionaryTags(json.map(function (tag) { return new DictionaryTag_1.DictionaryTag(tag); }));
    },
    toJSON: function (entity) {
        return entity.tags.map(function (tag) { return tag.value; });
    }
};
var DictionaryTags = /** @class */ (function () {
    function DictionaryTags(tags) {
        this.tags = tags;
    }
    DictionaryTags.prototype.toValue = function () {
        return this.tags.map(function (tag) { return tag.value; });
    };
    return DictionaryTags;
}());
exports.DictionaryTags = DictionaryTags;
//# sourceMappingURL=DictionaryTags.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionaryTags.js
// module id = 173
// module chunks = 0